import noop from 'lib/function/noop'
import { createContext, useContext } from 'react'
import type { ChatMapContextValue, ChatMapMarker } from './types'

const defaultValue: ChatMapContextValue = {
  activePlaceId: null,
  setActivePlaceId: noop,
  focusPlace: noop,
  markers: [],
}

export const ChatMapContext = createContext<ChatMapContextValue>(defaultValue)

export function useChatMapContext() {
  return useContext(ChatMapContext)
}

/**
 * Find a marker by placeId from the markers array
 */
export function findMarkerByPlaceId(
  markers: Array<ChatMapMarker>,
  placeId: string,
): ChatMapMarker | undefined {
  return markers.find(marker => marker.placeId === placeId)
}
